var $2761a0f3628b99b4$exports = {};
// Marks the nav anchor of the section in view (#508). Without
// IntersectionObserver the anchors still work, just unmarked.
const $2761a0f3628b99b4$var$anchors = [
    ...document.querySelectorAll("a[data-nav-anchor]")
];
const $2761a0f3628b99b4$var$sections = $2761a0f3628b99b4$var$anchors.map((a)=>document.getElementById(a.hash.slice(1))).filter((s)=>s !== null);
function $2761a0f3628b99b4$var$mark(id) {
    for (const a of $2761a0f3628b99b4$var$anchors)if (a.hash === `#${id ?? ""}`) a.setAttribute("aria-current", "true");
    else a.removeAttribute("aria-current");
}
if ("IntersectionObserver" in window) {
    const visible = new Set();
    const observer = new IntersectionObserver((entries)=>{
        for (const e of entries)if (e.isIntersecting) visible.add(e.target.id);
        else visible.delete(e.target.id);
        $2761a0f3628b99b4$var$mark($2761a0f3628b99b4$var$sections.find((s)=>visible.has(s.id))?.id ?? null);
    }, {
        rootMargin: "-96px 0px -50% 0px"
    });
    for (const s of $2761a0f3628b99b4$var$sections)observer.observe(s);
}


//# sourceMappingURL=path0.dc5b574a.js.map
